export const locale = {
  lang: 'en',
  data: {
    'CONFIRM': {
      'CONFIRM': 'Confirm',
      'CANCEL': 'Cancel',
    },
  }
};
